module.exports = __webpack_public_path__ + "static/media/IMG_5283.d7ac5d73.JPG";